import   React              from "react";

import   classNames         from "classnames";

import   styles              from "./SubscriptionManagment.module.scss";

import   SubscriptionList    from "./SubscriptionList";

import { useTypedSelector  } from "../../../store/useTypeSelector";
import { RootState         } from "../../../store/generalReducer";

export interface SubscriptionManagmentProps {
  email?: string;
}

// Onglet "Abonnements" : abonnements récurrents (quota créateur en mode abonnement)
// du créateur — scopé sur `email` s'il est fourni (fiche d'un créateur ouverte par
// un superadmin), sinon sur authentication.admin.email (compte connecté), même
// pattern que PurchaseHistory pour l'onglet "Achats".
export const SubscriptionManagment: React.FC<SubscriptionManagmentProps> = ({ email: emailProp }) => {

  const { authentication } = useTypedSelector((state: RootState) => state.authenticationReducer);

  const email = emailProp ?? authentication.admin?.email;

  if (!email) {
    return (
      <div className={classNames(styles.root)}>
        Chargement du profil...
      </div>
    );
  }

  return (
    <div className={classNames(styles.root)}>
      <SubscriptionList userEmail={email} />
    </div>
  );
};

export default SubscriptionManagment;
